import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Resources.css';

import { resourceCards } from './resourceList';

const Resources = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="main-hero demo-hero">
        <div className="hero-gif-fade-left"></div>
        <div className="hero-gif-fade-right"></div>
        <h1 className="hero-page-title">Research</h1>
      </section>

      <section className="res-content">
        <div className="res-layout">
          <p className="res-description">
            Explore blogs, whitepapers, and case studies on AI security, governance, and compliance from the Bltz AI team.
          </p>

          <div className="res-grid">
            {resourceCards.map((card, i) => (
              <div key={i} className="res-card" onClick={() => { navigate(`/resources/${card.slug}`); window.scrollTo(0, 0); }}>
                <img src={card.img} alt="" className="res-card-img" />
                <div className="res-card-text">
                  <span className="res-card-category">{card.category}</span>
                  <h3 className="res-card-title">{card.title}</h3>
                  <p className="res-card-desc">{card.desc}</p>
                  <span className="res-card-tag">{card.tag}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="res-cta">
            <button className="res-cta-btn" onClick={() => { navigate('/book-demo'); window.scrollTo(0, 0); }}>
              Get a Live Demo &rarr;
            </button>
          </div>

          <span className="res-back-link" onClick={() => { navigate('/'); window.scrollTo(0, 0); }} style={{ cursor: 'pointer' }}>
            ← Back to Home
          </span>
        </div>
      </section>
    </>
  );
};

export default Resources;
